import IndLogo from "../assest/img/kenyalanding/indiapropexpologo.png";
import IntroLogo from "../assest/img/kenyalanding/Introductions-logo.png";
import ToiLogo from "../assest/img/kenyalanding/toi.png";
// import HongKongbanner from "../assest/img/banner-image.jpg";
import HongKongbanner from "../assest/img/singapore-background.jpg";
import Pune from "../assest/img/kenyalanding/cities/pune.png";
import Mumbai from "../assest/img/kenyalanding/cities/mumbai.png";
import Gujarat from "../assest/img/kenyalanding/cities/Gujarat.png";
import DelhiNCR from "../assest/img/kenyalanding/cities/delhi-ncr.png";
import Gurugram from "../assest/img/kenyalanding/cities/gurugram.png";
import Hyderabad from "../assest/img/kenyalanding/cities/Hyderabad.png";
import Chennai from "../assest/img/kenyalanding/cities/chennai.png";
import Bangalore from "../assest/img/kenyalanding/cities/bangalore.png";
import Dubai from "../assest/img/kenyalanding/cities/Dubai.png";
import Goa from "../assest/img/kenyalanding/cities/Goa.png";
import Noida from "../assest/img/kenyalanding/cities/Noida.png";
import HotIcon from "../assest/img/kenyalanding/hot.png";
import DealIcon from "../assest/img/kenyalanding/deal.png";
import GiftIcon from "../assest/img/kenyalanding/gift.png";
import Residentialimg from "../assest/img/kenyalanding/residentialimg.png";
import Plot from "../assest/img/kenyalanding/plots.png";
import Villa from "../assest/img/kenyalanding/villa.jpg";
import Commercial from "../assest/img/kenyalanding/commercial.png";
import Developers from "../assest/img/kenyalanding/developers.png";
import Projects from "../assest/img/kenyalanding/projects.png";
import Cities from "../assest/img/kenyalanding/15-cities.png";
import Gall1 from "../assest/img/kenyalanding/WhatsApp Image 2024-05-07 at 4.35.49 PM.jpeg";
import Gall2 from "../assest/img/kenyalanding/WhatsApp Image 2024-05-07 at 4.34.27 PM (1).jpeg";
import Gall3 from "../assest/img/kenyalanding/WhatsApp Image 2024-05-07 at 4.34.26 PM.jpeg";
import Gall4 from "../assest/img/kenyalanding/WhatsApp Image 2024-05-07 at 4.34.27 PM.jpeg";
import Gall5 from "../assest/img/kenyalanding/expo.png";
import { Helmet } from "react-helmet";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import VisitorRegistrationFormIPE from "../Components/IPEForm/VisitorRegistrationFormIPE";
import "./KenyaLanding.css";
export default function KenyaLanding() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Open modal after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      handleShow();
    }, 2000); // 5 seconds delay

    return () => clearTimeout(timer); // Cleanup timeout on component unmount
  }, []);
  useEffect(() => {
    const scrollBox = document.querySelector(".seven-cards-box");

    if (window.innerWidth <= 568) {
      let scrollAmount = 0;

      const scrollInterval = setInterval(() => {
        if (scrollBox) {
          scrollBox.scrollBy({ left: 100, behavior: "smooth" });
          scrollAmount += 100;

          if (
            scrollBox.scrollLeft + scrollBox.offsetWidth >=
            scrollBox.scrollWidth
          ) {
            scrollAmount = 0;
            scrollBox.scrollTo({ left: 0, behavior: "smooth" });
          }
        }
      }, 2000);

      // Cleanup interval on unmount
      return () => clearInterval(scrollInterval);
    }
  }, []); // Run once on component mount

  useEffect(() => {
    // Check if the GTM iframe has been inserted using sessionStorage
    // if (!sessionStorage.getItem('gtmIframeInserted')) {
    //   const noscript = document.createElement('noscript');
    //   noscript.innerHTML = `
    //     <iframe id="gtm-noscript-iframe" src="https://www.googletagmanager.com/ns.html?id=GTM-T85X9JZG" height="0" width="0"
    //       style="display: none; visibility: hidden"></iframe>`;
    //   document.body.insertBefore(noscript, document.body.firstChild);

    //   // Mark that the GTM iframe has been inserted in sessionStorage
    //   sessionStorage.setItem('gtmIframeInserted', 'true');
    // }

    if (!window.gtmNoscriptInserted) {
      const noscriptTag = document.createElement("noscript");
      noscriptTag.innerHTML = `
        <iframe id="gtm-noscript-iframe" src="https://www.googletagmanager.com/ns.html?id=GTM-T85X9JZG" height="0" width="0" 
          style="display: none; visibility: hidden"></iframe>
      `;

      // Insert the noscript tag inside the body, right after the body tag starts
      const body = document.body;
      const firstChild = body.firstChild;
      body.insertBefore(noscriptTag, firstChild);

      // Mark the tag as inserted
      window.gtmNoscriptInserted = true;
    }

    // Check if Schema.org Organization script exists
    if (
      !document.querySelector(
        'script[type="application/ld+json"][data-schema="organization"]',
      )
    ) {
      const schemaOrgScript1 = document.createElement("script");
      schemaOrgScript1.type = "application/ld+json";
      schemaOrgScript1.setAttribute("data-schema", "organization");
      schemaOrgScript1.innerHTML = `{
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "India Prop Expo",
        "alternateName": "India Prop Expo",
        "url": "https://indiapropexpo.com/",
        "logo": "https://indiapropexpo.com/static/media/logo-transparent.4101ef7eae207e7ba017.png",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91 78800 38782",
          "contactType": "customer service",
          "areaServed": "IN",
          "availableLanguage": "en"
        },
        "sameAs": [
          "https://www.facebook.com/indiarealtyshow",
          "https://www.instagram.com/timesofindiarealtyshow/"
        ]
      }`;
      document.head.appendChild(schemaOrgScript1);
    }

    // Check if Schema.org Website script exists
    if (
      !document.querySelector(
        'script[type="application/ld+json"][data-schema="website"]',
      )
    ) {
      const schemaWebSiteScript = document.createElement("script");
      schemaWebSiteScript.type = "application/ld+json";
      schemaWebSiteScript.setAttribute("data-schema", "website");
      schemaWebSiteScript.innerHTML = `{
        "@context": "https://schema.org/",
        "@type": "WebSite",
        "name": "India Prop Expo",
        "url": "https://indiapropexpo.com/",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://indiapropexpo.com/{search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }`;
      document.head.appendChild(schemaWebSiteScript);
    }
  }, []);

  return (
    <>
      <Helmet>
        {/* Google tag (gtag.js) */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-1W471072FE"></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-1W471072FE');
      `}
        </script>
        {/* End Google Tag Manager */}

        {/* Google tag (gtag.js) */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-16481109907"></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'AW-16481109907');
      `}
        </script>
        {/* Google tag (gtag.js) End */}

        {/* Event snippet for Register as a visitor conversion page */}
        <script>
          {`
        gtag('event', 'conversion', { 'send_to': 'AW-16481109907/wlxGCMrirLoaEJOP57I9' });
      `}
        </script>
        {/* Event snippet for Register as a visitor conversion page End */}

        {/* Meta Pixel Code */}
        <script>
          {`
        !function(f, b, e, v, n, t, s) {
          if (f.fbq) return; n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
          };
          if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
          n.queue = []; t = b.createElement(e); t.async = !0;
          t.src = v; s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '670572972112062');
        fbq('track', 'PageView');
      `}
        </script>
        <noscript>
          {`
        <img
          height="1"
          width="1"
          style="display:none"
          src="https://www.facebook.com/tr?id=670572972112062&ev=PageView&noscript=1"
        />
      `}
        </noscript>
        {/* End Meta Pixel Code */}
        <title>
          India Property Expo 2026 - Exclusive India Property Expo in Singapore
        </title>

        <meta
          name="title"
          content="India Property Expo 2026 - Exclusive India Property Expo in Singapore"
        />
        <meta
          name="description"
          content="Register now to join the 2026 India Property Exhibition in Singapore  Book your slot now to buy your dream property in India!"
        />
        <meta
          name="keyword"
          content="India property expo Singapore, property fair in Singapore, nri real estate events, Real Estate Exhibition, real estate property show, Luxury Apartments in India for NRIs, Villas and Plots in India for Sale, Buy Property in India from Singapore, Property deal in Delhi NCR, Property Deal in Mumbai, Property Deal in Bangalore, Property Deal in Hyderabad, Property Deal in Chennai, Property Deal in Pune, Property Deal in Goa, Property Deal in Kolkata, residential property deals, commercial property deals, Buy Plots in India, Buy Commercial Spaces in India, Villa Property deals, Buy Villas in India,  Indians, Non Resident Indians (NRI's), People of Indian Origin (PIO's), Overseas Citizen of India, India property expo Singapore 2026, property fairs in Singapore to buy property in india, Singapore property show"
        />
        <meta
          property="og:title"
          content="India Property Expo 2026 - Exclusive India Property Expo in Singapore"
        />
        <meta
          property="og:description"
          content="Register now to join the 2026 India Property Exhibition in Singapore  Book your slot now to buy your dream property in India!"
        />
        <meta property="og:site_name" content="India Realty Show" />
        <meta property="og:url" content="https://indiapropexpo.com/" />
        <meta
          property="og:image"
          content="https://indiapropexpo.com/static/media/indiapropexpologo.bb5ef163d51e392164ce.png"
        />

        <link rel="canonical" href="https://indiapropexpo.com/" />

        <meta
          property="twitter:title"
          content="INDIA PROPERTY EXPO 2026 - Exclusive India Property Expo in Singapore"
        />
        <meta
          property="twitter:description"
          content="Discover premier property deals from Bangalore, Chennai, Pune, Vadodara, Mumbai, Delhi, Gurugram and many more in Singapore at the."
        />
        <meta
          name="twitter:image"
          content="https://indiapropexpo.com/static/media/indiapropexpologo.bb5ef163d51e392164ce.png"
        />
        <script>
          {`
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');

      fbq('init', '1346393204095371');
      fbq('track', 'PageView');
    `}
        </script>

        <noscript>
          {`
      <img
        height="1"
        width="1"
        style="display:none"
        src="https://www.facebook.com/tr?id=1346393204095371&ev=PageView&noscript=1"
      />
    `}
        </noscript>
      </Helmet>
      <div className="kenya-landing-page">
        <section id="navbar" className="sticky-top shadow-sm">
          <nav className="navbar navbar-expand-md navbar-white bg-white">
            <div className="container-fluid">
              <div className=" p-0">
                <a className="navbar-brand m-0 main-logo" href="">
                  <img src={IndLogo} alt="India Realty Show Logo" />
                  <p>Singapore</p>
                </a>
              </div>
              <div className=" btn-register" onClick={handleShow}>
                Free Visitor Registration
              </div>
              {/* //  <div className=" p-0">
              //   <a className="navbar-brand m-0" href="./">
              //     <img src={ToiLogo} alt="Times of India Logo" />
              //   </a>
              // </div>  */}
            </div>
          </nav>
        </section>
        <section>
          <div className="container-fluid ">
            <div className="row banner">
              <img
                src={HongKongbanner}
                className="mobile-banner img-fluid"
                alt="Singapore"
              />
              <div className="banner-content">
                <img src={IndLogo} alt="India Realty Show Logo" />

                <p>
                  {/* <strong>Hotel IL FIORE Kasai Annex</strong> */}
                  <strong>Ascott Raffles Place Singapore</strong>
                  <br />
                  2 Finlayson Green Singapore 049247,
                  <br />( 1 min Walk from Raffles Place MRT )
                </p>
                <a
                  href=" https://maps.app.goo.gl/inX9XL3LetKyRBHJ6"
                  target="_blank"
                  rel="noopener noreferrer">
                  <i className="fa-solid fa-location-dot"></i> Click here for
                  direction
                </a>
                <p className="mb-0 event-time">
                  <b>
                    5<sup>th</sup> & 6<sup>th</sup> September 2026
                  </b>
                </p>
                <p className="mb-0 mt-2">
                  {" "}
                  <b>
                    Time: 10:30 AM to 8:00 PM (Sat-Sun) Book Your Slot Today
                  </b>
                </p>
                <p className="mb-0">
                  {" "}
                  <b>Entry & Parking Free</b>
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="form-bg">
          <div className="container">
            <div className="row">
              <div className="col-12 px-lg-0">
                <VisitorRegistrationFormIPE />
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-4">
            <div className="row align-items-center">
              <div className="col-12 mb-4">
                <div className="section-two-right">
                  <h1 className="heading-style">
                    India Property Expo - Singapore
                  </h1>
                  <h2 className="aos-init aos-animate mt-4">
                    2 Days of Incredible Deals
                  </h2>
                  <div className="project-contents-msp pb-2 aos-init aos-animate mb-3">
                    on properties from all across India
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-6 aos-init aos-animate">
                      <div className="single-services">
                        <div className="icon">
                          <img
                            src={HotIcon}
                            className="w-100"
                            alt="Unbeatable Deals"
                          />
                        </div>
                        <h3>Unbeatable Deals</h3>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 aos-init aos-animate">
                      <div className="single-services">
                        <div className="icon">
                          <img
                            src={DealIcon}
                            className="w-100"
                            alt="Flexible Payment Plans"
                          />
                        </div>
                        <h3>Flexible Payment Plans</h3>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 aos-init aos-animate">
                      <div className="single-services mb-0">
                        <div className="icon">
                          <img
                            src={GiftIcon}
                            className="w-100"
                            alt="Incredible Pre-Launch Offers"
                          />
                        </div>
                        <h3>Incredible Pre-Launch Offers</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mb-3 mb-lg-0">
                <div className="seven-cards-box">
                  <div className="seven-card">
                    <img src={Bangalore} className="img-fluid" alt="Chennai" />
                  </div>
                  <div className="seven-card">
                    <img src={Dubai} className="img-fluid" alt="Chennai" />
                  </div>
                  <div className="seven-card">
                    <img src={Mumbai} className="img-fluid" alt="Mumbai" />
                  </div>
                  <div className="seven-card">
                    <img src={Pune} className="img-fluid" alt="Pune" />
                  </div>
                  <div className="seven-card">
                    <img src={Goa} className="img-fluid" alt="Goa" />
                  </div>
                  <div className="seven-card">
                    <img src={Noida} className="img-fluid" alt="Noida" />
                  </div>
                  <div className="seven-card">
                    <img src={DelhiNCR} className="img-fluid" alt="Delhi NCR" />
                  </div>
                  <div className="seven-card">
                    <img src={Gurugram} className="img-fluid" alt="Gurugram" />
                  </div>
                  <div className="seven-card">
                    <img
                      src={Hyderabad}
                      className="img-fluid"
                      alt="Hyderabad"
                    />
                  </div>
                  <div className="seven-card">
                    <img src={Chennai} className="img-fluid" alt="Chennai" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container-fluid bg-event bg-g mb-4">
          <div className="row position-relative">
            <div className="col-12">
              <div className="hero-content">
                <h2 className="aos-init">Free Entry</h2>
                <p style={{ fontSize: "30px" }} className="aos-init">
                  Snacks & High Tea will be provided to all Registered Clients
                </p>
              </div>
            </div>
          </div>
        </div>
        <section className="features-area pt-0 section-bg-msp">
          <div className="container">
            <div className="section-title mb-3">
              <h2 className="aos-init aos-animate">
                Get Projects across <br /> Residential, Plots, Villas &amp;
                Commercial{" "}
              </h2>
              <div className="project-contents-msp aos-init aos-animate">
                Ranging from 30 lacs to 15 Crores
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 mb-4 mb-lg-0 aos-init aos-animate">
                <div className="card">
                  <a className="popup-with-form" onClick={handleShow}>
                    <div className="single-features">
                      <img src={Residentialimg} alt="residential" />
                      <div className="project-title-msp">RESIDENTIAL</div>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-3 mb-4 mb-lg-0 aos-init aos-animate">
                <div className="card">
                  <a className="popup-with-form" onClick={handleShow}>
                    <div className="single-features">
                      <img src={Plot} alt="Plots" />
                      <div className="project-title-msp">PLOTS</div>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-3 mb-4 mb-lg-0 aos-init aos-animate">
                <div className="card">
                  <a className="popup-with-form" onClick={handleShow}>
                    <div className="single-features">
                      <img src={Villa} alt="villa" />
                      <div className="project-title-msp">VILLA</div>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-3 mb-4 mb-lg-0 aos-init aos-animate">
                <div className="card">
                  <a className="popup-with-form" onClick={handleShow}>
                    <div className="single-features">
                      <img src={Commercial} alt="commercial" />
                      <div className="project-title-msp">COMMERCIAL</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="container-fluid bg-g mt-4">
          <div className="row align-items-center position-relative">
            <div className="col-lg-12 col-md-12">
              <div className="hero-content">
                <h2 className="aos-init aos-animate">
                  "Exclusive for Indians in Singapore"
                </h2>
                <p
                  style={{ color: "#ffcc00", fontSize: "30px" }}
                  className="aos-init aos-animate">
                  Meet Top Indian Developers for one on one discussion right
                  here in Singapore{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        <section>
          <div className="container py-4">
            <div className="row">
              <div className="col-lg-4 mb-3 mb-lg-0">
                <div className="developers-card">
                  <img
                    className="w-100"
                    src={Developers}
                    alt="20+ Developers"
                  />
                  <div className="card-constant  w-100">
                    <h3 className="text-center">15+</h3>
                    <p className="text-center">Developers</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 mb-3 mb-lg-0">
                <div className="developers-card">
                  <img
                    className="w-100"
                    src={Projects}
                    alt="100 + Projects with Exclusive Deals"
                  />
                  <div className="card-constant  w-100">
                    <h3 className="text-center">50+</h3>
                    <p className="text-center">Projects with Exclusive Deals</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-3 mb-lg-0">
                <div className="developers-card">
                  <img className="w-100" src={Cities} alt="15 + Cities" />
                  <div className="card-constant  w-100">
                    <h3 className="text-center">15+</h3>
                    <p className="text-center">Cities</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="glimpses-area mb-4 pb-3">
          <div className="section-title">
            <h2 className="aos-init aos-animate">
              Glimpses of Previous Property Expos
            </h2>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-4 d-lg-block d-none">
                <img
                  src={Gall1}
                  className="w-100"
                  alt="Glimpses of Previous Property Expos"
                />
              </div>
              <div className="col-8 d-lg-block d-none">
                <div className="row">
                  <div className="col-4">
                    <img
                      className="w-100"
                      src={Gall2}
                      alt="Glimpses of Previous Property Expos"
                    />
                  </div>

                  <div className="col-4">
                    <img
                      src={Gall3}
                      className="w-100"
                      alt="Glimpses of Previous Property Expos"
                    />
                  </div>
                  <div className="col-4">
                    <img
                      src={Gall4}
                      className="w-100"
                      alt="Glimpses of Previous Property Expos"
                    />
                  </div>
                </div>
                <div className="col-12 mt-3 d-flex">
                  <img
                    className="w-100"
                    src={Gall5}
                    alt="Glimpses of Previous Property Expos"
                  />
                </div>
              </div>
            </div>
            <div className="row d-lg-none d-block">
              <div className="col-md-4 mb-3">
                <img
                  className="w-100"
                  src={Gall1}
                  alt="Glimpses of Previous Property Expos"
                />
              </div>
              <div className="col-md-4 mb-3">
                <img
                  className="w-100"
                  src={Gall2}
                  alt="Glimpses of Previous Property Expos"
                />
              </div>
              <div className="col-md-4 mb-3">
                <img
                  className="w-100"
                  src={Gall3}
                  alt="Glimpses of Previous Property Expos"
                />
              </div>
              <div className="col-md-4 mb-3">
                <img
                  className="w-100"
                  src={Gall4}
                  alt="Glimpses of Previous Property Expos"
                />
              </div>
              <div className="col-md-4 mb-3">
                <img
                  className="w-100"
                  src={Gall5}
                  alt="Glimpses of Previous Property Expos"
                />
              </div>
            </div>
          </div>
        </section>

        {/* <section className="py-4">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-title">
                <h2 data-aos="zoom-in" className="aos-init aos-animate">
                  Exhibitors
                </h2>
              </div>
            </div>
            <div className="col-12">
              <Swiper
                slidesPerView={1}
                spaceBetween={10}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                  },
                  1024: {
                    slidesPerView: 5,
                    spaceBetween: 50,
                  },
                }}
                modules={[Pagination]}
                className="mySwiper">
                <SwiperSlide></SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section> */}

        <footer className="bg-light py-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 col-lg-2 mb-4 mb-lg-0">
                <a href="">
                  <img
                    src={IndLogo}
                    className="img-fluid"
                    alt="India Realty Show Logo"
                  />
                </a>
              </div>
              <div className="col-md-6 col-lg-3 mb-4 mb-lg-0 ps-lg-4">
                <p className="mb-0" style={{ fontSize: "14px" }}>
                  <strong style={{ fontSize: "16px" }}>
                    {" "}
                    Ascott Raffles Place Singapore
                  </strong>
                  <br />2 Finlayson Green Singapore 049247, <br /> ( 1 min Walk
                  from Raffles Place MRT )
                </p>

                <a
                  href=" https://maps.app.goo.gl/inX9XL3LetKyRBHJ6"
                  target="_blank"
                  rel="noopener noreferrer">
                  <i className="fa-solid fa-location-dot"></i> Click here for
                  direction
                </a>
              </div>
              <div className="col-md-6 col-lg-3 ps-lg-5">
                <ul className="footer-contact-links">
                  <li>
                    <a href="tel:+919322228089">
                      <i className="fa-solid fa-phone"></i> +91 93222 28089
                    </a>
                  </li>
                  <li>
                    <a href="https://wa.me/+919322228089">
                      <i className="fa-brands fa-whatsapp"></i> +91 93222 28089
                    </a>
                  </li>
                  <li>
                    <a href="mailto:sales.infairs@gmail.com">
                      <i className="fa-solid fa-envelope"></i>
                      <span>sales.infairs@gmail.com</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-6 col-lg-2">
                <b>Follow Us On</b>
                <ul className="footer-contact-links mt-2">
                  <li>
                    <a
                      href="https://www.facebook.com/sakalglobalrealtyexpo"
                      target="_blank">
                      <i className="fa-brands fa-facebook"></i> Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/sakalglobalrealtyexpo/"
                      target="_blank">
                      <i className="fa-brands fa-instagram"></i> Instagram
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-6 col-lg-2 mb-4 mb-lg-0">
                <b className="d-block">Organized By</b>
                <img
                  src={IntroLogo}
                  className="img-fluid mt-2"
                  alt="Introduction Trade Shows Logo"
                />
              </div>
              <div className="col-lg-8 mx-auto text-center">
                <p className="footer-text">
                  Note that only Resident Indians, Non Resident Indians (NRI) ,
                  People of Indian Origin ( PIO), Overseas Citizen of India
                  (OCI) & Resident Indians living in India or Abroad are Allowed
                  to buy properties in India . This site is not a part of the
                  Facebook website or Facebook Inc . Additionally this site is
                  not endorsed by Facebook or FACEBOOK, Inc. in any way.
                </p>
              </div>
            </div>
          </div>
        </footer>
        <div className="container-fluid px-lg-4 bg-dark py-2">
          <div className="row">
            <div className="col-md-6 text-center text-lg-start text-white">
              <p className="cursive-font mb-0 pt-1">
                Come visit and buy your dream property
              </p>
            </div>
            <div className="col-md-6 text-white text-center text-lg-end">
              <a
                href="/privacy-policy"
                className="w-auto mt-2 d-inline-block text-white text-decoration-none">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton className="model-cross-visitor">
            <Modal.Title>Free Visitor Registration</Modal.Title>
          </Modal.Header>
          <Modal.Body className="model-cross-visitor ipe-form-modal p-0">
            <VisitorRegistrationFormIPE />
          </Modal.Body>
        </Modal>
        <div className="fixed-bottom d-block bg-white p-2 d-lg-none">
          <div className=" btn-register w-100" onClick={handleShow}>
            Free Visitor Registration
          </div>
        </div>
      </div>
    </>
  );
}
